import React from 'react';

import {LoginForm} from "../../module";
import Logo from "../../../Image/Logo.png";
import "./Login.css"
import {SnackbarProvider} from "notistack";
import {useSelector} from "react-redux";
import {selBaseStatus} from "../../../stores/base/baseSlice";

function Login() {

    return (
        <div className="d-flex flex-column justify-content-center
                            align-items-center bgImage overflow-hidden"
             style={{height: `100vh`, width: `100%`}}
        >
            <div className="divParentBg w-100 d-flex flex-column justify-content-center align-items-center">

                <div
                    className="bg d-flex flex-column align-items-center justify-content-center"
                >
                    <img
                        src={Logo}
                        className="Logo mb-30px mb-3"
                        alt=""
                    />
                    <LoginForm/>
                </div>
            </div>
        </div>
    );
}


export default function IntegrationNotistack() {
    return (
        <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: "top", horizontal: "center"}}>
            <Login/>
        </SnackbarProvider>
    );
}

